import React from "react";
import SectionImg from "../../common/images/Expert-Android.png";
const ExpertAndroid = () => {
  return (
    <div>
      <div className="relative  bg-cover bg-center bg-no-repeat text-black small:py-7 py-5 ">
        {/* Main Heading */}
        <div className="max-w-[1280px] mx-auto text-center px-5 md:px-10 md:py-7 py-5">
          <div className="">
            <h2 className="small:text-4xl text-3xl font-bold md:text-5xl">
              Simplified Development Process{" "}
            </h2>
            <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
              <p className="h-[5px] rounded-xl bg-primary w-[50%]"></p>
            </div>
          </div>
          <p className="mt- font-semibold max-w-5xl mx-auto">
            We have designed a streamlined process to design projects for
            maximum effectiveness and a smooth workflow.{" "}
          </p>
        </div>

        {/* Image Below Paragraph */}
        <div className="mt-6 flex justify-center">
          <img
            src={SectionImg}
            alt="Illustration"
            className="w-full px-5 md:max-w-5xl"
          />
        </div>
      </div>
    </div>
  );
};

export default ExpertAndroid;
